import { render, staticRenderFns } from "./En_about.vue?vue&type=template&id=28a627b3&scoped=true"
import script from "./En_about.vue?vue&type=script&lang=js"
export * from "./En_about.vue?vue&type=script&lang=js"
import style0 from "./En_about.vue?vue&type=style&index=0&id=28a627b3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28a627b3",
  null
  
)

export default component.exports